export default __webpack_public_path__ + "static/media/404-ill.140d50a9.webp";